import {useContext, useEffect, useState} from "react";
import {Paper, Typography, useTheme} from "@mui/material";
import {useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import ContentBody from "../../../../common/content-body/ContentBody";
import {findGeneralTimeframe, findSpecificTimeframe} from "../../../RsDetail.actions";
import {IGeneralTimeframe, ISpecificTimeframe} from "../../../models";
import {SET_SNACKBAR} from "../../../../common/utils";
import {GlobalContext} from "../../../../../../util/state/GlobalContextProvider";
import GeneralTimeframe from './TimeframePanel/GeneralTimeframe';
import SpecificTmeframe from './TimeframePanel/SpecificTmeframe';
import { defaultGeneralTimeframe } from "./TimeframePanel/config";

const TimeframePanel = () => {
    const {t} = useTranslation(["network", "translation"]);
    const theme = useTheme();
    const params = useParams(); 
    const {dispatchGlobalData} = useContext(GlobalContext);
    const [generalTimeframe, setGeneralTimeframe] = useState<IGeneralTimeframe[]>(defaultGeneralTimeframe);
    const [specificTimeframe, setSpecificTimeframe] = useState<ISpecificTimeframe[]>([]);
    const [isDisabledGeneral, setIsDisabledGeneral] = useState(true);
    const [isDisabledSpecific, setIsDisabledSpecific] = useState(true);

    useEffect(() => {
        const reqParams = { id: params?.id };
        findGeneralTimeframe(reqParams)
            .then((response: any) => {
                if(response.generalTimeFrame.length === 7){
                    setGeneralTimeframe(response.generalTimeFrame);
                }
            })
            .catch(() => { dispatchGlobalData(SET_SNACKBAR.ERROR) })

        findSpecificTimeframe(reqParams)
            .then((response: any) => { setSpecificTimeframe(response.specificTimeFrame) })
            .catch(() => { dispatchGlobalData(SET_SNACKBAR.ERROR) })
    }, []);

    return (
        <ContentBody>
            <Typography variant="h5">
                {t("rsDetail.timeframe.header.title")}
            </Typography>

            <Paper elevation={1} sx={{p: theme.spacing(2), mb: theme.spacing(2)}}>
                <GeneralTimeframe
                    disabled={isDisabledGeneral}
                    setDisabled={setIsDisabledGeneral}
                    curTimeframe={generalTimeframe}
                    setCurTimeframe={setGeneralTimeframe}
                />

                <SpecificTmeframe
                    disabled={isDisabledSpecific}
                    setDisabled={setIsDisabledSpecific}
                    curTimeframe={specificTimeframe}
                    setCurTimeframe={setSpecificTimeframe}
                />
            </Paper>
        </ContentBody>
    )
}

export default TimeframePanel;
